<div class="w-full h-full inline-block align-middle" *ngIf="!iframeLoaded">
    <div class="flex justify-center w-full md:mt-11 pb-8">
        <img src="assets/icons/Icons/other-payment-options/payJustNowLogo.svg" alt="pay-just-now logo">
    </div>
    <div class="flex justify-center pt-4 pb-6">
        <h3 class="text-center"><b>Please wait while you are redirected to PayJustNow<sup>TM</sup></b></h3>
    </div>
    <div class="flex justify-center pt-4 pb-8">
        <mat-spinner></mat-spinner>
    </div>
    <p class="subtext flex justify-center">Redirecting in <countdown class="text-lg" [config]="config" style="margin-left: 5px;"></countdown></p>
</div>
<div class="w-full h-full inline-block align-middle" *ngIf="!iframeLoaded && iframePostback">
    <div class="flex justify-center w-full md:mt-11 pb-8">
        <img src="assets/icons/Icons/other-payment-options/payJustNowLogo.svg" alt="ozow logo">
    </div>
    <div class="flex justify-center pt-4 pb-6">
        <h3 class="text-center"><b>Confirming Transaction Status</b></h3>
    </div>
    <div class="flex justify-center pt-4 pb-8">
        <mat-spinner></mat-spinner>
    </div>
</div>
<iframe name="output_frame" *ngIf="!iframePostback" class="external-iframe" [src]="controllerUrl" [attr.data-loaded]="iframeLoaded" #output_frame (load)="iframeOnLoad($event)"></iframe>
